import { useEffect } from 'react';
import { pdfjs } from 'react-pdf';

export const useReactPdf: () => void = () => {
  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
  }, []);
};
